import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-frame',
  templateUrl: './frame.component.html',
  styleUrls: ['./frame.component.scss']
})
export class FrameComponent implements OnInit {

  constructor(protected titleService: Title) { 
    titleService.setTitle("FirstConnect - Users");
  }

  ngOnInit(): void {
  }

}
